// extracted by mini-css-extract-plugin
export default {"jobSubmission":"style_jobSubmission__kQPGw","container":"style_container__lAkUt","icon":"style_icon__+N1Ta","text":"style_text__2A1kU"};